// extracted by mini-css-extract-plugin
export default {"middleNameInput":"middle-name-input__middle-name-input__id4_0"};